module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_01_b4772bf97.png";